import api from "./api";
import StorageService from "./StorageService";

const ProjectService = {
  getAllProjects: async (companyId, pageNumber, noofRows, search = "") => {
    const login = StorageService.loginData();
    const employeeId = login?.employeeId || "";
    const roleId = login?.roleId || "";
    const res = await api.get(`/projects/getAll/${companyId}?pageNumber=${pageNumber}&noofRows=${noofRows}&search=${search}&employeeId=${employeeId}&roleId=${roleId}`);
    return res.data;
  },

  getActive: async (companyId) => {
    const login = StorageService.loginData();
    const employeeId = login?.employeeId || "";
    const roleId = login?.roleId || "";
    const response = await api.get(`/projects/getActive/${companyId}?employeeId=${employeeId}&roleId=${roleId}`);
    return response.data;
  },

  getActiveProjectsByCompany: async (companyId) => {
    return api.get(`/projects/getActive/${companyId}`);
  },

  getActiveProjectsByEmployee: async (companyId, employeeId) => {
    return api.get(`/projects/getByEmployeeId/${companyId}/${employeeId}`);
  },
  saveProject: async (data) => {
    return api.post("/projects/save", data);
  },

  getById: async (id) => {
    return api.get(`/projects/getById/${id}`);
  },
  updateProject: async (id, data) => api.put(`/projects/update/${id}`, data),
  updateStatus: async (id) => {
    const res = await api.put(`/projects/updateStatus/${id}`);
    return res;
  },

  // getById: async (id) => {
  //   return api.get(`/project/id/${id}`);
  // },

  // updateProject: async (id, data) => {
  //   return api.put(`/project/id/${id}`, data);
  // },

  // updateStatus: async (id, status) => {
  //   return api.delete(`/project/id/${id}`, { data: { status } });
  // },

  getAssignedProjects: async (companyId, employeeId) => {
    return api.get(`/projects/assignedProjects/${companyId}/${employeeId}`);
  },


};

export default ProjectService;
